import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { CustomerActivityReportModal } from './CustomerActivityReportModal';
import { ProductConfigurationReportModal } from './ProductConfigurationReportModal';
import { TransportHistoryReportModal } from './TransportHistoryReportModal';

export function ReportsPage() {
  const [showCustomerActivityModal, setShowCustomerActivityModal] = useState(false);
  const [showProductConfigurationModal, setShowProductConfigurationModal] = useState(false);
  const [showTransportHistoryModal, setShowTransportHistoryModal] = useState(false);

  return (
    <Container>
      <Row className="justify-content-between mb-2">
        <div className="col-auto">
          <h2 className="col-auto ka-blue">Reports</h2>
        </div>
      </Row>
      <Row className="mb-3">
        <Col className="mb-3">
          <div 
            className="card border h-100 position-relative"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowCustomerActivityModal(true)}
            data-testid="customer-activity-report-card"
          >
            <div className="card-header card-header-content-sm-between mb-0 pb-0 pt-3">
              <h4 className="card-header-title text-center ka-blue">Customer Activity Report</h4>
            </div>
            <hr className="hr mt-2 mb-2 mx-5" />
            <div className="card-body py-3 px-3 d-flex flex-column justify-content-center">
              <div className="text-center mb-3">
                <i className="bi bi-file-text fs-1 ka-blue"></i>
              </div>
              <p className="text-center text-muted">
                Generate a comprehensive report showing customer order transaction activity with product measurements and operational details.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="mb-3">
          <div 
            className="card border h-100 position-relative"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowProductConfigurationModal(true)}
            data-testid="product-configuration-report-card"
          >
            <div className="card-header card-header-content-sm-between mb-0 pb-0 pt-3">
              <h4 className="card-header-title text-center ka-blue">Product Configuration Report</h4>
            </div>
            <hr className="hr mt-2 mb-2 mx-5" />
            <div className="card-body py-3 px-3 d-flex flex-column justify-content-center">
              <div className="text-center mb-3">
                <i className="bi bi-file-text fs-1 ka-blue"></i>
              </div>
              <p className="text-center text-muted">
                Generate a CSV report showing all products configured in Constellation, including site assignments and defined density values, to help verify product setup across systems.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="mb-3">
          <div
            className="card border h-100 position-relative"
            style={{ cursor: 'pointer' }}
            onClick={() => setShowTransportHistoryModal(true)}
            data-testid="transport-history-report-card"
          >
            <div className="card-header card-header-content-sm-between mb-0 pb-0 pt-3">
              <h4 className="card-header-title text-center ka-blue">Transport History Report</h4>
            </div>
            <hr className="hr mt-2 mb-2 mx-5" />
            <div className="card-body py-3 px-3 d-flex flex-column justify-content-center">
              <div className="text-center mb-3">
                <i className="bi bi-file-text fs-1 ka-blue"></i>
              </div>
              <p className="text-center text-muted">
				Generate a detailed report showing which customer orders and product mixes were loaded into each transport compartment, including quantities, product measurements, and associated operational details.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <CustomerActivityReportModal
        show={showCustomerActivityModal}
        onHide={() => setShowCustomerActivityModal(false)}
      />
      <ProductConfigurationReportModal
        show={showProductConfigurationModal}
        onHide={() => setShowProductConfigurationModal(false)}
      />
      <TransportHistoryReportModal
        show={showTransportHistoryModal}
        onHide={() => setShowTransportHistoryModal(false)}
      />
    </Container>
  );
}
